export default "__VITE_ASSET__DV0H0Zxq__"